export default "__VITE_ASSET__wi$DlDxu__"